import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import CompleteIcon from "./assets/complete.png";
import Lottie from "lottie-react";
import * as animationData from "@/assets/loading-user.json";

const PayLoading = ({ payStatus }: { payStatus: string }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.6)",
        zIndex: 20,
        display: payStatus === "loading" ? "block" : "none",
      }}
    >
      <Flex
        sx={{
          position: "fixed",
          bottom: "0",
          left: "0",
          width: "100%",
          height: "100px",
          background: "#fff",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {payStatus === "loading" && (
          <>
            <Lottie
              animationData={animationData}
              loop={true}
              style={{
                width: "32px",
                height: "32px",
              }}
            />
            <Text
              sx={{
                color: "#773400",
                textAlign: "center",
                fontSize: "14px",
                marginTop: "8px",
              }}
            >
              Payment in progress...{" "}
            </Text>
          </>
        )}

        {payStatus === "complete" && (
          <Flex alignItems={"center"} justifyContent={"center"}>
            <Text
              sx={{
                color: "#773400",
                textAlign: "center",
                fontSize: "14px",
                marginRight: "8px",
              }}
            >
              Payment completed
            </Text>
            <Image
              src={CompleteIcon}
              alt="complete"
              width={"22px"}
              height={"22px"}
            />
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default PayLoading;
